import { userActions } from "../slices/user";

import { ThunkAction } from "redux-thunk";
import { RootState } from "../store"; // Assuming your store file is named 'store.ts'
import { Action } from "redux";
import { notificationActions } from "../slices/notification";
import { load_storage, save_storage } from "../../utils/localstorage";
import { requestApi } from "./common";

interface ProfileData {
  mobile: string;
}

// Define types for thunk actions
type ThunkResult<R> = ThunkAction<R, RootState, undefined, Action<string>>;

export const getProfile = (reqData: any): ThunkResult<void> => {
  return async (dispatch) => {
    // dispatch(notificationActions.toggleLoading(true));

    const res = await requestApi<{
      token_type: string;
      access_token: string;
      data: Record<string, any>;
    }>(`${process.env.REACT_APP_API_BASE_URL}auth/login`, "POST", reqData);

    if (res.error) {
      // dispatch(notificationActions.toggleLoading(false));
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      dispatch(
        userActions.auth({
          tokenType: res.data.token_type,
          access_token: res.data.access_token,
          profileData: JSON.parse(atob(res.data.access_token.split(".")[1])),
          roleType:
            JSON.parse(atob(res.data.access_token.split(".")[1]))?.role?.[0] ??
            2,
        })
      );
      save_storage<string>("access_token", `Bearer ${res.data.access_token}`);
    }

    //   dispatch(notificationActions.toggleLoading(false));
  };
};

export const signUp = (reqData: any): ThunkResult<void> => {
  return async (dispatch) => {
    // dispatch(notificationActions.toggleLoading(true));

    const res = await requestApi<{
      token_type: string;
      token: string;
      data: Record<string, any>;
    }>(`${process.env.REACT_APP_API_BASE_URL}auth/signup`, "POST", reqData);

    if (res.error) {
      // dispatch(notificationActions.toggleLoading(false));
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }

    if (res.data) {
      dispatch(
        userActions.auth({
          tokenType: "Bearer",
          token: res.data.token,
          profileData: res.data.data.user,
        })
      );
      save_storage<string>("access_token", `Bearer ${res.data.token}`);
    }

    //   dispatch(notificationActions.toggleLoading(false));
  };
};

export const createStore = (reqData: any): ThunkResult<void> => {
  return async (dispatch) => {
    // dispatch(notificationActions.toggleLoading(true));

    const res = await requestApi<{
      token_type: string;
      token: string;
      data: Record<string, any>;
    }>(`${process.env.REACT_APP_API_BASE_URL}manage/store`, "POST", reqData);

    if (res.error) {
      // dispatch(notificationActions.toggleLoading(false));
      dispatch(
        notificationActions.toggleNotification({
          title: "Error",
          description: res.error,
          type: "error",
        })
      );
    }
    console.log("wedsvklzclj", res);
    // @ts-ignore
    return res?.data?.status === "success";

    //   dispatch(notificationActions.toggleLoading(false));
  };
};

export const refresh = (): ThunkResult<void> => {
  return async (dispatch) => {
    const token: string = load_storage("access_token");

    if (!token) {
      dispatch(notificationActions.toggleInitalLoading(false));
    } else {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}auth/refresh`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          }
        );
        const data = await res.json();

        if (!res.ok) {
          dispatch(
            notificationActions.toggleNotification({
              title: "Session expired",
              type: "error",
            })
          );
          dispatch(notificationActions.toggleInitalLoading(false));
          // dispatch(notificationActions.toggleLoading(false));
          // dispatch(notificationActions.toggleError("Failed fetching user"));
          return;
        }

        if (data) {
          dispatch(
            userActions.auth({
              tokenType: data.token_type,
              access_token: data.access_token,
              profileData: JSON.parse(atob(data.access_token.split(".")[1])),
              roleType:
                JSON.parse(atob(data.access_token.split(".")[1]))?.role?.[0] ??
                2,
            })
          );
          // save_storage<string>("access_token", `${"bearer"} ${data.token}`);
          dispatch(notificationActions.toggleInitalLoading(false));
        }
      } catch (error) {
        // Handle error
        dispatch(notificationActions.toggleInitalLoading(false));
      }
    }
  };
};
